import React from 'react';
import { ALERT_SOURCES } from '../alertSources';

// Tab row: the four agency alert sources + ScamWire (the open-source scam
// reporting, formerly "Hot Scams"). A red badge marks tabs with unexpired New
// items. The active tab is underlined and bold.
const TABS = [...ALERT_SOURCES, { id: 'hot-scams', label: 'ScamWire' }];

const AlertSourceTabs = ({ activeSource, onSelect, newBySource = {} }) => (
  <div className="flex items-center justify-between gap-2 py-4 border-b border-gray-300">
    {TABS.map((tab) => {
      const isActive = tab.id === activeSource;
      return (
        <button
          key={tab.id}
          type="button"
          onClick={() => onSelect(tab.id)}
          className={`relative px-2 xl:px-4 py-1 text-xl xl:text-2xl whitespace-nowrap transition-colors border-b-2 -mb-[17px] pb-3 ${
            isActive
              ? 'text-black font-semibold border-gray-800'
              : 'text-gray-700 hover:text-black border-transparent'
          }`}
        >
          {tab.label}
          {newBySource[tab.id] && (
            <span className="absolute top-0 -right-1 bg-red-500 text-white text-[11px] leading-none rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center font-bold">
              !
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default AlertSourceTabs;
